import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, Popconfirm, Table} from "antd";
import {Edit, Edit2, Menu as MENU, Trash2, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import {RiEjectLine} from "react-icons/ri";
import {BiCheckDouble} from "react-icons/bi";
import {MdDone} from "react-icons/md";

export default function Walls() {
    const history = useHistory();
    const [usersData, setUsersData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobileShow, setIsMobileShow] = useState(false);
    useEffect(() => {
        LoadWalls();
    }, []);

    const LoadWalls = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadWalls");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setUsersData(result.data);
                            setFilterData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const handleSearch = (value) => {
        if (value) {
            const filtered = filterData.filter((item) => item.Wall.toLowerCase().includes(value.trim().toLowerCase()) || item.FireResistance.toLowerCase().includes(value.trim().toLowerCase()));
            setUsersData(filtered);
        } else {
            setUsersData(filterData);
        }

    };

    async function deleteWall(id) {
        let toaster;
        toaster = toast.loading("Processing...");
        try {
            const formdata = new FormData();
            formdata.append("page", "DeleteWall");
            formdata.append("id", id);
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    if (result.status === 1) {
                        setTimeout(() => {
                            toast.update(toaster, {
                                type: "success",
                                render: "Record Deleted!",
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })

                        }, 1000)
                        LoadWalls();
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                })
                .catch(error => console.log('error', error));
        } catch (e) {
            console.log(e);
        }
    }

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <h2>Walls</h2>
                    <span>want to manage the walls?</span>
                    <div className="content-card">
                        <div className="table-search">
                            <input type="search" placeholder='Type to search...'
                                   onChange={(e) => handleSearch(e.target.value)}/>
                            <div>
                                <button className='btn-card-header' style={{marginRight: 5,}}
                                        onClick={() => history.push('/user/add-wall', {data: null})}>Add
                                    Wall
                                </button>
                                <button className='btn-card-header'
                                        onClick={() => history.push('/user/add-wall-select')}>Add
                                    Wall Select
                                </button>
                            </div>
                        </div>
                        <Table dataSource={usersData} pagination={{pageSize: 10}}
                               loading={isLoading}
                               rowHoverable={true} style={{marginTop: 40}}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }}/>
                            <Table.Column title="Wall" dataIndex="Wall"/>
                            <Table.Column title="Fire Resistance" dataIndex="FireResistance"/>
                            <Table.Column title="Acoustic Rating" dataIndex="AcousticRating"/>
                            <Table.Column title="System Width" dataIndex="SystemWidth"/>
                            <Table.Column title="Pressure" dataIndex="Pressure"/>
                            <Table.Column title="Wall Height" dataIndex="WallHeight"/>
                            <Table.Column title="Stud Width" dataIndex="StudWidth"/>
                            <Table.Column title="Impact Resistance (One Side)" dataIndex="ImpactResistance_one"/>
                            <Table.Column title="Impact Resistance (Other Side)" dataIndex="ImpactResistance_other"/>
                            <Table.Column title="Moisture Resistance (One Side)" dataIndex="MoistureResistance_one"/>
                            <Table.Column title="Moisture Resistance (Other Side)"
                                          dataIndex="MoistureResistance_other"/>
                            <Table.Column title="Mould Resistance (One Side)" dataIndex="MouldResistance_one"/>
                            <Table.Column title="Mould Resistance (Other Side)" dataIndex="MouldResistance_other"/>
                            <Table.Column title="System Number" dataIndex="SystemNo"/>
                            <Table.Column title="First Lining" dataIndex="FirstLining"/>
                            <Table.Column title="Second Lining" dataIndex="SecondLining"/>
                            <Table.Column title="Third Lining" dataIndex="ThirdLining"/>
                            <Table.Column title="Reference" dataIndex="Ref"/>
                            <Table.Column title="Side One" dataIndex="SideOne"/>
                            <Table.Column title="Side Two" dataIndex="SideTwo"/>
                            <Table.Column title="Masonry" dataIndex="Masonry"/>
                            <Table.Column title="Insulation" dataIndex="Insulation"/>
                            <Table.Column title="R Value" dataIndex="RVal"/>
                            <Table.Column title="Date" dataIndex="Date"/>
                            <Table.Column title="Edit" render={(j) => {
                                return (
                                    <Button type='primary' icon={<Edit2 size={15}/>} onClick={() => {
                                        history.push('/user/add-wall', {data: j});
                                    }}/>
                                )
                            }}/>
                            <Table.Column title="Delete" render={(j) => {
                                return (
                                    <Popconfirm title={'Are you sure?'}
                                                description={'You want to remove this wall?'}
                                                onConfirm={() => {
                                                    deleteWall(j.id)
                                                }}
                                    >
                                        <Button type='primary' danger icon={<Trash2 size={15}/>}/>
                                    </Popconfirm>
                                )
                            }}/>


                        </Table>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
